import { useState } from "react";
import { Bookmark } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function SaveLookButton({ imageUrl, title = "", source = "brand", startupId = "", dropId = "", className = "" }) {
    const { user } = useAuth();
    const [saved, setSaved] = useState(false);

    const save = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!user) { toast.error("Log in to save looks"); return; }
        if (user.role !== "user") { toast.error("Only shopper accounts can save looks"); return; }
        try {
            await api.post("/me/saved-looks", { image_url: imageUrl, title, source, startup_id: startupId, drop_id: dropId });
            setSaved(true);
            toast.success("Saved to your profile");
        } catch { toast.error("Try again"); }
    };

    return (
        <button
            data-testid="save-look-btn"
            onClick={save}
            aria-label="Save look"
            className={`p-2 rounded-full backdrop-blur-md transition-colors ${
                saved ? "bg-brand-saffron text-black" : "bg-black/60 text-white hover:bg-brand-saffron hover:text-black"
            } ${className}`}
        >
            <Bookmark className={`w-4 h-4 ${saved ? "fill-current" : ""}`} />
        </button>
    );
}
